module.exports = __webpack_public_path__ + "static/img/pdf.aa34f747.png";